import * as React from 'react';
import { SVGProps } from 'react';

const IconDocDeleteSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 2c0-.5.5-1 1-1h3.5c.248 0 .373 0 .48.044.109.045.198.134.379.315l2.263 2.263c.194.194.289.289.335.403.043.108.043.232.043.475V10c0 .5-.5 1-1 1H3c-.5 0-1-.5-1-1V2zm7 2L7 2v1.5a.5.5 0 0 0 .5.5H9zM4.232 6.44l.707-.708L6 6.792l1.06-1.06.708.707L6.708 7.5l1.06 1.06-.707.708L6 8.208l-1.06 1.06-.708-.707L5.292 7.5l-1.06-1.06z"
    />
  </svg>
);
export default IconDocDeleteSizeXs;
